import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default () => {
  Vue.component('fa-icon', FontAwesomeIcon);
};
